import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const findAll = async (query) => {
  return axios.request({
    method: 'GET',
    url: '/api/passengers',
    params: query,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const getAllPassengers = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/passengers?limit=100000',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const savePassenger = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/passengers',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updatePassenger = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/passengers/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deletePassenger = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/passengers/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  findAll,
  getAllPassengers,
  savePassenger,
  deletePassenger,
  updatePassenger,
}
